module.exports = __webpack_public_path__ + "static/team-1090710c5e4f07f5ab3c14fca150d131.jpg";